import { FieldState, FieldValidator } from 'final-form';

// FIXME write tests & support Promises!
export function composeValidators<T>(validators: Array<FieldValidator<T>>): FieldValidator<T> {
  return (value: T, allValues?: object, meta?: FieldState<T>) => {
    let result: any;
    validators.some((validator) => {
      const error = validator(value, allValues, meta);
      if (error) {
        result = error;
        return true;
      }
    });

    return result;
  };
}
